/* Essencraft PDP behaviors: anchor scrolls, sticky purchase anchor (neutral,
   scroll-only), FAQ/media tracking. Vanilla JS.
   This file must never read, mirror, write or submit Recharge/product-form
   state. All purchase interaction belongs to the original transaction region. */
(function () {
  'use strict';

  function track(name, payload) {
    if (window.ecTrack) window.ecTrack(name, payload);
  }

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function scrollToEl(el, block) {
    var rect = el.getBoundingClientRect();
    var top = rect.top + window.scrollY - (block === 'center' ? Math.max(0, (window.innerHeight - rect.height) / 2) : 90);
    if (reducedMotion()) {
      window.scrollTo(0, top);
      return;
    }
    try {
      window.scrollTo({ top: top, behavior: 'smooth' });
    } catch (e) {
      window.scrollTo(0, top);
    }
    // some embedded/emulated browsers ignore smooth scrolling entirely —
    // verify movement and fall back to an instant jump
    setTimeout(function () {
      if (Math.abs(window.scrollY - top) > Math.abs(rect.top) * 0.9 && Math.abs(rect.top) > 200) {
        window.scrollTo(0, top);
      }
    }, 600);
  }

  function focusNeutral(target) {
    target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
  }

  function initJumpLinks() {
    document.querySelectorAll('[data-ec-jump]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var id = (link.getAttribute('href') || '').replace('#', '');
        var target = document.getElementById(id);
        if (!target) return;
        e.preventDefault();
        scrollToEl(target, 'start');
        var heading = target.querySelector('h2, h3');
        if (heading) focusNeutral(heading);
        if (link.dataset.ecJump === 'testing') track('ec_coa_open', { source: 'pdp_jump_link' });
      });
    });
  }

  /* Neutral mobile purchase anchor: appears after the original purchase
     module leaves the viewport; contains only the short title and a
     "View purchase options" button that scrolls to #ec-primary-purchase.
     It never displays or submits purchase state. */
  function initStickyAnchor() {
    var bar = document.querySelector('[data-ec-sticky-anchor]');
    var purchase = document.getElementById('ec-primary-purchase');
    if (!bar || !purchase) return;

    var ticking = false;
    function updateBar() {
      ticking = false;
      var rect = purchase.getBoundingClientRect();
      bar.classList.toggle('is-visible', rect.bottom < 0);
    }
    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(updateBar);
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    updateBar();

    var btn = bar.querySelector('[data-ec-sticky-view]');
    if (btn) {
      btn.addEventListener('click', function () {
        scrollToEl(purchase, 'start');
        focusNeutral(purchase);
      });
    }
  }

  /* Final visual CTA: scroll-only return to the original purchase area. */
  function initFinalCta() {
    document.querySelectorAll('[data-ec-final-cta]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var purchase = document.getElementById('ec-primary-purchase');
        if (!purchase) return;
        track('ec_final_cta_click', {});
        scrollToEl(purchase, 'start');
        focusNeutral(purchase);
      });
    });
  }

  function initFaqTracking() {
    document.querySelectorAll('[data-ec-faq-item]').forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (item.open) track('ec_faq_open', { faq_id: item.id || null });
      });
    });
  }

  function initFormatCompareTracking() {
    document.querySelectorAll('[data-ec-format-compare]').forEach(function (link) {
      link.addEventListener('click', function () {
        track('ec_format_compare_click', {});
      });
    });
  }

  function initSupportEscalationTracking() {
    document.querySelectorAll('[data-ec-support-link]').forEach(function (link) {
      link.addEventListener('click', function () {
        track('ec_support_escalation_click', {});
      });
    });
  }

  function boot() {
    initJumpLinks();
    initStickyAnchor();
    initFinalCta();
    initFaqTracking();
    initFormatCompareTracking();
    initSupportEscalationTracking();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
